import React, { Component } from 'react';
import Detallepedido from './../Detallepedido/';
import Detalleremesa from './../Detalleremesa/';
import Detalleformapago from './../Detalleformapago/';
import Detallepedidoreferencias from './../Detallepedidoreferencias/';
import Detallelistaempaque from './../Detallelistaempaque/'; 
import Detallemovimientoinventarioentrada from './../Detallemovimientoinventarioentrada/';  
import Detallemovimientoinventariosalida from './../Detallemovimientoinventariosalida/';  
import Detallefacturaotrosconceptos from './../Detallefacturaotrosconceptos/'; 
import Detallefacturaservicios from './../Detallefacturaservicios/'; 
import Detallecomercialcomision from './../Detallecomercialcomision/'; 
import Detallecomercialmetaindicador from './../Detallecomercialmetaindicador/'; 
import Detallepedidocumplido from './../Detallepedidocumplido/'; 

import Detalleusuarioalmacenes from './../Detalleusuarioalmacenes/'; 
import Detalleusuarioclientes from './../Detalleusuarioclientes/'; 
import Detalleusuariosucursales from './../Detalleusuariosucursales/'; 
import Detalleusuariopaginas from './../Detalleusuariopaginas/'; 

class Loaderdetalle extends Component {

  getComponentToRender = () => {
    const detalle = this.props.setComponente;
    switch (detalle) {
      case 'pedido':
        return <Detallepedido setData={this.props.setData}
          datosHeader={this.props.datosHeader}
          editData={this.props.editData ? this.props.editData : null}
          setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;
      case 'facturaOtrosConceptos':
        return <Detallefacturaotrosconceptos setData={this.props.setData}
          datosHeader={this.props.datosHeader}
          editData={this.props.editData ? this.props.editData : null}
          setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;   
      case 'facturaServicios':
        return <Detallefacturaservicios setData={this.props.setData}
          datosHeader={this.props.datosHeader}
          editData={this.props.editData ? this.props.editData : null}
          setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;                    
      case 'pedidoReferencias':
        return <Detallepedidoreferencias setData={this.props.setData}
          datosHeader={this.props.datosHeader}
          editData={this.props.editData ? this.props.editData : null}
          setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;
    case 'listaEmpaque':
            return <Detallelistaempaque setData={this.props.setData}
              datosHeader={this.props.datosHeader}
              editData={this.props.editData ? this.props.editData : null}
              setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;  
    case 'pedidoCumplido':
      return <Detallepedidocumplido setData={this.props.setData}
        datosHeader={this.props.datosHeader}
        editData={this.props.editData ? this.props.editData : null}
        setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;               
    case 'comercial':
      return <Detallecomercialcomision setData={this.props.setData}
        datosHeader={this.props.datosHeader}
        editData={this.props.editData ? this.props.editData : null}
        setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;
    case 'comercialMeta':
      return <Detallecomercialmetaindicador setData={this.props.setData}
        datosHeader={this.props.datosHeader}
        editData={this.props.editData ? this.props.editData : null}
        setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;                           
    case 'movimientoInventarioEntrada':
            return <Detallemovimientoinventarioentrada setData={this.props.setData}
              datosHeader={this.props.datosHeader}
              editData={this.props.editData ? this.props.editData : null}
              setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;   
    case 'movimientoInventarioSalida':
            return <Detallemovimientoinventariosalida setData={this.props.setData}
              datosHeader={this.props.datosHeader}
              editData={this.props.editData ? this.props.editData : null}
              setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;                                   
    case 'remesa':
      return <Detalleremesa setData={this.props.setData}
        datosHeader={this.props.datosHeader}
        editData={this.props.editData ? this.props.editData : null}
        setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;
    case 'usuarioAlmacenes':
      return <Detalleusuarioalmacenes setData={this.props.setData}
        datosHeader={this.props.datosHeader}
        editData={this.props.editData ? this.props.editData : null}
        setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;   
    case 'usuarioSucursales':
      return <Detalleusuariosucursales setData={this.props.setData}
        datosHeader={this.props.datosHeader}
        editData={this.props.editData ? this.props.editData : null}
        setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;  
    case 'usuarioClientes':
      return <Detalleusuarioclientes setData={this.props.setData}
        datosHeader={this.props.datosHeader}
        editData={this.props.editData ? this.props.editData : null}
        setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;  
    case 'usuarioPaginas':
      return <Detalleusuariopaginas setData={this.props.setData}
        datosHeader={this.props.datosHeader}
        editData={this.props.editData ? this.props.editData : null}
        setIndex={this.props.setIndex !== null ? this.props.setIndex : null} />;                             
    case 'formapago':
      return <Detalleformapago setData={this.props.setData} />;
    default:
      return null;
    }
  }

  render() {
    return (
      <div>
        {this.getComponentToRender()}
      </div>
    );
  }
}

export default Loaderdetalle;